export enum EN_默认_BRANCH_NAME {
  默认 = '默认',
}
